<template>
  <div class="login-container">
    <div class="login-main">
      <div class="main-left"></div>
      <div class="main-right">
        <div class="login-title">客服管理后台登录</div>
        <el-form ref="form" :rules="rules" :model="form">
          <el-form-item prop="loginId">
            <el-input v-model.trim="form.loginId" placeholder="账号" @keyup.native.enter="login('form')"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model.trim="form.password" type="password" placeholder="密码" @keyup.native.enter="login('form')"></el-input>
          </el-form-item>
          <el-button type="primary" :loading="isLogin" @click="login('form')">
            <span v-if="isLogin">登录中</span>
            <span v-else>登 录</span>
          </el-button>
        </el-form>
      </div>
    </div>
    <Wave/>
  </div>
</template>

<script>
import Wave from '../Public/Wave.vue'
import {authLogin} from '../../api/public/auth'
export default {
  name: 'Home',
  components: {
    Wave
    // Foot
  },
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign, 1)
    if (this.$route.hash) {
      let hashData = this.$route.hash.split('?')
      this.accessToken = hashData[0].split('#access_token=')
      if (this.accessToken[1]) {
        let data = {
          ucenterToken: this.accessToken[1]
        }
        authLogin(data).then(info => {
          if (info.data.resultCode === 0) {
            global.$sider = ''
            this.$store.dispatch('login', info.data.resultData)
            this.$router.push({name: 'Index'})
          } else {
            this.$message.error(info.data.resultMessage)
          }
        })
      }
    }
  },
  watch: {
    $route (to, from) {
    }
  },
  data () {
    return {
      isLogin: false,
      accessToken: '',
      form: {
        loginId: '',
        password: ''
      },
      rules: {
        loginId: [
          {required: true, message: '账户名称不能为空', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
  },
  methods: {
    // 登录
    login (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            nickname: this.form.loginId,
            password: this.form.password,
            platformId: this.$store.state.Auth.platformInfo.id
          }
          this.isLogin = true
          authLogin(data).then(info => {
            this.isLogin = false
            if (info.data.resultCode === 0) {
              global.$sider = ''
              this.$store.dispatch('login', info.data.resultData).then(() => {
                this.$router.push({name: 'Index'})
              })
            } else {
              this.$message.error(info.data.resultMessage)
            }
          }).catch(() => {
            this.isLogin = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login-container{
  position: relative;
  width: 100%;
  height: 100vh;
  background: url('../../common/img/logbg.png') center no-repeat;
  background-size: cover;
  .login-main{
    display: flex;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 840px;
    height: 440px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 2px 2px 11px rgba(0, 0, 0, .5);
    .main-left{
      flex: 1;
      background: url('../../common/img/log-box-img.png') center no-repeat;
      background-size: cover;
    }
    .main-right{
      padding: 60px 28px 28px;
      width: 360px;
      background: #fff;
      .login-title{
        font-size: 28px;
        font-weight: 600;
        color: #666;
        text-align: center;
      }
      /deep/.el-form{
        margin-top: 40px;
        .el-form-item{
          margin-bottom: 26px;
          input.el-input__inner{
            height: 50px;
          }
        }
      }
      .el-button{
        font-size: 18px;
        margin-top: 10px;
        width: 100%;
      }
    }
  }
}
// .login{
//   position: relative;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
// }
// .header{
//   margin-bottom: 0;
//   margin-top: 0;
//   height: 90px;
//   border-bottom: 1px solid #e7e7e7;
//   background: #ffffff;
// }
// .headerlogo{
//   width: 188px;
//   line-height: 90px;
// }
</style>



// WEBPACK FOOTER //
// src/components/Auth/Login.vue